// External
import React from 'react';

// Internal
import classnames from 'classnames/bind';
import ss from './Group.scss';

const cx = classnames.bind(ss);

type HeaderProps = {
  children: React.ReactNode;
  title?: string,
  classes?: string,
  description?: string,
};

export default function Header({
  title = '',
  description = '',
  classes = '',
  children,
}: HeaderProps): JSX.Element {
  return (
    <div className={cx(ss['image-group'], classes)}>
      {title && (
        <div className={ss.header}>
          <span className={cx(ss.title)}>{title}</span>
          { description && (
            <p className={ss.description}>{description}</p>
          )}
        </div>
      )}
      <div className={ss.children}>
        {children}
      </div>
    </div>
  );
}
